export default __webpack_public_path__ + "static/media/chris-dacre-graveyard.38e704b4.jpg";